import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_json_forms = _resolveComponent("json-forms")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($data.resolvedSchema.resolved && $data.resolvedSchema.error === undefined)
      ? (_openBlock(), _createBlock(_component_json_forms, {
          key: 0,
          data: $props.example.input.data,
          schema: $data.resolvedSchema.schema,
          uischema: $props.example.input.uischema,
          renderers: $props.renderers,
          config: $props.config,
          uischemas: $props.uischemas,
          validationMode: $props.validationMode,
          ajv: $props.ajv,
          readonly: $props.readonly,
          i18n: $data.i18n,
          onChange: $options.onChange
        }, null, 8, ["data", "schema", "uischema", "renderers", "config", "uischemas", "validationMode", "ajv", "readonly", "i18n", "onChange"]))
      : (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
          default: _withCtx(() => [
            (!$data.resolvedSchema.resolved)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  class: "fill-height",
                  "align-content": "center",
                  justify: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      class: "text-subtitle-1 text-center",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Resolving Schema Refs ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_linear, {
                          indeterminate: "",
                          rounded: "",
                          height: "6"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : ($data.resolvedSchema.error !== undefined)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    class: "fill-height",
                    "align-content": "center",
                    justify: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "text-subtitle-1 text-center",
                        cols: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_alert, {
                            color: "red",
                            dark: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($data.resolvedSchema.error), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }))
  ]))
}